import React, { Component } from 'react'
import { Table, Icon, Dropdown, Menu, Modal } from 'antd'
import className from 'classnames'
import { api } from '../../../../services'

export default class extends Component {
  state = {
    localLoading: false
  }

  updateDivisionById = (id, data) => {
    const { callback } = this.props

    this.setState({
      localLoading: true
    })

    api.division.updateDivisionById(id, data)
      .then(() => {
        this.setState({
          localLoading: false
        })
        callback()
      })
      .catch(() => {
        this.setState({
          localLoading: false
        })
      })
  }

  deleteDivisionById = (id) => {
    const { callback } = this.props

    this.setState({
      localLoading: true
    })

    api.division.deleteDivisionById(id)
      .then(() => {
        this.setState({
          localLoading: false
        })
        callback()
      })
      .catch(() => {
        this.setState({
          localLoading: false
        })
      })
  }

  showDeactivateConfirm = (record) => {
    Modal.confirm({
      title: 'Want to deactivate this division? Please, be aware that all its users will be deactivated and not able to log in.',
      okText: 'Deactivate',
      okType: 'red',
      cancelText: 'Cancel',
      onOk: () => {
        this.updateDivisionById(record.id, { ...record, active: false })
      },
      onCancel () {}
    })
  }

  showDeleteConfirm = (id) => {
    const { list } = this.props
    const division = list.filter(d => d.id === id)[0]

    if(division.usedLicenseNumber > 0) {
      Modal.error({
        title: 'There are users assigned to this division! Please, contact the organisation admin if you really want to delete it.',
        okType: 'red'
      })
    } else {
      Modal.confirm({
        title: 'Do you want to delete this division?',
        okText: 'Yes',
        okType: 'red',
        cancelText: 'No',
        onOk: () => {
          this.deleteDivisionById(id)
        },
        onCancel () {}
      })
    }
  }

  manageDivisionLicensesById = (id, data) => {
    const { callback } = this.props

    this.setState({
      localLoading: true
    })

    api.division.manageDivisionLicensesById(id, data)
      .then(() => {
        this.setState({
          localLoading: false
        })
        callback()
      })
      .catch(() => {
        this.setState({
          localLoading: false
        })
      })
  }

  render () {
    const { list, loading, selectDivision } = this.props
    const { localLoading } = this.state

    const columns = [{
      title: 'Organization',
      dataIndex: 'organization',
      width: '15%',
      render: (value) => {
        return value.name
      }
    }, {
      title: 'Name',
      dataIndex: 'name',
      width: '25%',
      render: (value, record) => {
        return <div className='b-division-name'>
          <div className={className({ 'b-division-name__status': true, 'b-division-name__status_active': record.active })} />
          <div className='b-division-name__text'>{value}</div>
        </div>
      }
    }, {
      title: 'Number of licenses',
      dataIndex: 'licenseNumber',
      width: '20%',
      render: (value) => {
        return value
      }
    }, {
      title: 'Licenses used',
      dataIndex: 'usedLicenseNumber',
      width: '40%',
      render: (value, record) => {
        return <div className='b-division-used'>
          <div className='b-division-used__text'>{ value }</div>
          { record.requestedLicenseNumber &&
            <div className='b-division-used__request'>
              <div className='b-division-used__request-text'>Request to change number<br />of licenses to { record.requestedLicenseNumber}</div>
              <div className='b-division-used__request-buttons'>
                <div className='b-division-used__request-button b-division-used__request-button_approve' onClick={() => this.manageDivisionLicensesById(record.id, { approve: true })}>Approve</div>
                <div className='b-division-used__request-button b-division-used__request-button_decline' onClick={() => this.manageDivisionLicensesById(record.id, { approve: false })}>Decline</div>
              </div>
            </div>
          }
          <Dropdown trigger={['click']} overlay={
            record.active
              ? <Menu>
                <Menu.Item onClick={() => this.showDeactivateConfirm(record)}>
                  <Icon type='sync' />Deactivate
                </Menu.Item>
                <Menu.Item onClick={() => selectDivision(record)}>
                  <Icon type='edit' />Edit
                </Menu.Item>
              </Menu>
              : <Menu>
                <Menu.Item onClick={() => this.updateDivisionById(record.id, { ...record, active: true })}>
                  <Icon type='sync' />Activate
                </Menu.Item>
                <Menu.Item onClick={() => selectDivision(record)}>
                  <Icon type='edit' />Edit
                </Menu.Item>
                <Menu.Item style={{ color: 'red' }} onClick={() => this.showDeleteConfirm(record.id)}>
                  <Icon type='delete' />Delete
                </Menu.Item>
              </Menu>
          }>
            <div className='b-division-used__more'><Icon type='more' /></div>
          </Dropdown>
        </div>
      }
    }]

    return <Table
      loading={loading || localLoading}
      rowKey={record => record.id}
      dataSource={list}
      columns={columns}
    />
  }
}



// WEBPACK FOOTER //
// ./src/views/Divisions/components/TableContent/TableContent.jsx